import { DDLogo } from 'assets';
import { FC, PropsWithChildren } from 'react';

import './Layout.scss';

export const Layout: FC<PropsWithChildren> = ({ children }) => (
  <div className="layout">
    <div className="content">
      <div className="header">
        <img className="dd-logo" alt="Digitale Dörfer Logo" src={DDLogo} />
      </div>

      <div className="main">
        {children}

        <p className="support">
          <a href="https://ticket.digitale-doerfer.de/help/de-de">Support</a>
          <a href="https://smartesland.de/datenschutzerklaerung/">
            Datenschutz
          </a>
          <a href="https://smartesland.de/nutzungsbedingungen/">AGB</a>
          <a href="https://smartesland.de/impressum/">Impressum</a>
        </p>
      </div>
    </div>
  </div>
);
